import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Country } from '@utils/country';
import { Regexs } from '@utils/regex';
import { CasesService } from 'src/app/core/services/cases.service';
import { CountrysService } from 'src/app/services/countrys.service';
import { Estados } from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';

@Component({
  selector: 'app-person-involved-ras',
  templateUrl: './person-involved-ras.component.html',
  styleUrls: ['./person-involved-ras.component.scss'],
})
export class PersonInvolvedRasComponent implements OnInit {
  @Input() data: { task: any; personType: any };
  typeOfPerson: string = null;
  identification: string = null;

  constructor(
    private readonly fb: FormBuilder,
    private caseService: CasesService
  ) {}

  get isJuridicPerson() {
    return (
      this.typeOfPerson == 'J' ||
      this.typeOfPerson == 'I' ||
      this.typeOfPerson == 'G' ||
      this.typeOfPerson == 'R'
    );
  }
  form;
  estados = Estados;
  // formRelated: FormGroup = this.fb.group({
  //   otherPerson: [],
  // });
  tipoPersona;
  nacionalidad;
  async ngOnInit() {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.typeOfPerson = res.additionalInformation.numero_de_identificacion[0];
      this.identification = res.additionalInformation.numero_de_identificacion;
      console.log(this.identification);
      this.tipoPersona = res.additionalInformation.tipo_de_persona;
      this.nacionalidad = this.typeOfPerson == 'E' ? 'E' : 'V';
      if (this.isJuridicPerson) {
        this.buildLegalPersonForm();
      } else {
        this.buildNaturalPersonForm();
      }
    });
  }

  buildLegalPersonForm() {
    const { task } = this.data;

    const { data } = task;
    //filtramos solo el texto de los estados
    for (let e of this.estados) {
      this.est.push(e.estado);
    }
    try {
      if (data) {
        //filtramos los municipoos del estado seleccionado que vienen de data
        this.estMun = this.estados.filter((es) => {
          return es.estado == data.state;
        });
        //una vez obtenido el estado con sus municipios pasamos solo el texto de los municipios
        for (let e of this.estMun[0].municipio) {
          this.mun.push(e.municipio);
        }
        //tomamos el municipio seleccionado de data y filtramos solo las parroquias
        this.munParr = this.estMun[0].municipio.filter((munici) => {
          return munici.municipio == data.municipality;
        });
        this.parr = this.munParr[0].parroquias;
      }
    } catch (err) {
      console.log(err);
    }
    this.form = this.fb.group({
      businessName: [data?.businessName || '', [Validators.required]],
      rif: [this.identification],
      economicActivity: [data?.economicActivity || '', [Validators.required]],
      specificActivity: [data?.specificActivity || '', [Validators.required]],
      constitutionDate: [data?.constitutionDate || '', [Validators.required]],
      direction: [data?.direction || '', [Validators.required]],
      state: [data?.state || '', [Validators.required]],
      municipality: [data?.municipality || '', [Validators.required]],
      parish: [data?.parish || '', [Validators.required]],
      phone1: [data?.phone1 || '', [Validators.required]],
      phone2: [data?.phone2 || ''],
      institutionReportingClient: [
        data?.institutionReportingClient || false,
        [Validators.required],
      ],
    });
  }
  est = [];
  estMun = [];
  mun = [];
  munParr = [];
  parr = [];
  buildNaturalPersonForm() {
    const { task } = this.data;
    const { data } = task;

    //filtramos solo el texto de los estados
    for (let e of this.estados) {
      this.est.push(e.estado);
    }
    try {
      if (data) {
        //filtramos los municipoos del estado seleccionado que vienen de data
        this.estMun = this.estados.filter((es) => {
          return es.estado == data.state;
        });
        //una vez obtenido el estado con sus municipios pasamos solo el texto de los municipios
        for (let e of this.estMun[0].municipio) {
          this.mun.push(e.municipio);
        }
        //tomamos el municipio seleccionado de data y filtramos solo las parroquias
        this.munParr = this.estMun[0].municipio.filter((munici) => {
          return munici.municipio == data.municipality;
        });
        this.parr = this.munParr[0].parroquias;
      }
    } catch (err) {
      console.log(err);
    }
    this.form = this.fb.group({
      names: [data?.names || '', [Validators.required]],
      lastNames: [data?.lastNames || '', [Validators.required]],
      ciPassport: [this.identification, [Validators.required]],
      nationality: [this.nacionalidad, [Validators.required]],
      placeOfBirth: [data?.placeOfBirth || '', [Validators.required]],
      birthdate: [data?.birthdate || '', [Validators.required]],
      gender: [data?.gender || '', [Validators.required]],
      direction: [data?.direction || '', [Validators.required]],
      state: [data?.state || '', [Validators.required]],
      municipality: [data?.municipality || '', [Validators.required]],
      parish: [data?.parish || '', [Validators.required]],
      phone1: [data?.phone1 || '', [Validators.required]],
      phone2: [data?.phone2 || ''],
      occupation: [data?.occupation || '', [Validators.required]],
      economicActivity: [data?.economicActivity || '', [Validators.required]],
      specificActivity: [data?.specificActivity || '', [Validators.required]],
      institutionReportingClient: [
        data?.institutionReportingClient || false,
        [Validators.required],
      ],
      employmentRelationship: [
        data?.employmentRelationship || false,
        [Validators.required],
      ],
      institutionClientReportingClient: [
        data?.institutionClientReportingClient || false,
        [Validators.required],
      ],
      pasCi: [this.tipoPersona, [Validators.required]],
      // otherPerson: [data?.otherPerson || ''],
    });
  }
}
